import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";
import { PageHeader } from "../components/PageHeader";
import { CtaBanner } from "../components/CtaBanner";
import { Reveal } from "../lib/motion";

const PUNTI = [
  "Colloquio di orientamento per comprendere obiettivi e punto di partenza",
  "Individuazione del percorso più adatto alla tua situazione",
  "Accompagnamento e assistenza durante tutto il percorso di studi",
  "Un unico punto di riferimento per ogni passaggio",
];

export default function Diplomi() {
  usePageMeta(
    "Diplomi",
    "Percorsi per il conseguimento del diploma con orientamento personalizzato: Centro Studi Forma Futuro ti accompagna in ogni fase."
  );

  return (
    <main>
      <PageHeader
        testId="page-diplomi"
        eyebrow="Percorsi · Diplomi"
        title="Il tuo diploma, con un percorso su misura."
        description="Se vuoi conseguire il diploma, il primo passo è capire da dove parti e dove vuoi arrivare: per questo offriamo un orientamento personalizzato."
      />
      <section className="pb-20 lg:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <Reveal>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-navy text-balance">
                Prima di tutto, l'orientamento.
              </h2>
              <p className="mt-6 text-base text-slate-600 leading-relaxed">
                Ogni studente ha una storia diversa: età, impegni, tempo a
                disposizione e obiettivi cambiano da persona a persona. Per
                questo il percorso verso il diploma inizia con un colloquio,
                durante il quale valutiamo insieme la situazione e definiamo la
                strada più adatta.
              </p>
              <p className="mt-4 text-base text-slate-600 leading-relaxed">
                Durante tutto il percorso lo studente è seguito e supportato:
                non sei mai solo di fronte a scadenze, dubbi o passaggi
                importanti.
              </p>
              <ul className="mt-8 space-y-4">
                {PUNTI.map((p, i) => (
                  <li key={i} className="flex items-start gap-3.5">
                    <span className="mt-0.5 inline-flex items-center justify-center w-6 h-6 rounded-full bg-azure-light text-azure shrink-0">
                      <Check size={14} strokeWidth={3} />
                    </span>
                    <span className="text-sm sm:text-base text-slate-700 leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/contatti"
                data-testid="diplomi-cta"
                className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-azure px-7 py-3.5 text-sm font-bold text-white shadow-[0_18px_38px_-14px_rgba(36,85,138,0.65)] transition-all duration-300 hover:bg-[#1C446E] hover:-translate-y-0.5 group"
              >
                Richiedi un colloquio di orientamento
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Reveal>
            <Reveal delay={0.15} className="relative">
              <div className="rounded-[2rem] overflow-hidden border-8 border-white shadow-[0_40px_80px_-40px_rgba(8,42,89,0.45)]">
                <img
                  src="/assets/diplomi.jpg"
                  alt="Studente durante il percorso verso il diploma"
                  className="w-full h-[360px] sm:h-[480px] object-cover"
                />
              </div>
              <div className="absolute -top-8 -right-6 w-32 h-32 rounded-full border border-dashed border-azure-mid spin-slower pointer-events-none" />
            </Reveal>
          </div>
        </div>
      </section>
      <CtaBanner
        title="Vuoi riprendere gli studi?"
        text="Raccontaci la tua situazione: ti orientiamo verso il percorso di diploma più adatto a te."
      />
    </main>
  );
}
